import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import Profile from "../../../../assets/images/profile1.jpg";
import Socket from "../../../../socket/socket";
import _ from "lodash";
import TrippleArrows from "../../../../assets/images/teambuilding.png";
import { compose } from "redux";
import avatar from "../../../../assets/images/verboden/user.png";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import cx from "classnames";

const CategoryContent = ({
  buttonData,
  selectedIndex,
  onClickItem,
  type,
  roomData,
}) => {
  const players = useSelector((state) => state.gameReducer.roomObj?.users);
  const [activePlayerIndex, setActivePlayerIndex] = useState(0);
  // const playerName = activePlayer.display_name.split(" ");
  const nextPlayerIndex = (activePlayerIndex + 1) % players.length;

  const ib_category = _.get(roomData, "lobby_parameters.ib_category", null);

  let title = buttonData[selectedIndex].title;
  const gameCode = useSelector((state) => state.gameReducer.roomObj?.game_code);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [question, setQuestion] = useState("Loading...");
  const isLogoInsideCard = ["CT"].includes(type);
  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const ib_question = _.get(roomData, "lobby_parameters.ib_question");
  const ib_next_Player_index = _.get(
    roomData,
    "lobby_parameters.ib_next_player"
  );
  const ib_current_player_index = _.get(
    roomData,
    "lobby_parameters.ib_current_player"
  );
  const activePlayer = players[ib_current_player_index];
  const nextPlayer = players[ib_next_Player_index];
  console.log(nextPlayer, "nextPlayer==>");
  // updated
  const updatedAvatar = (title) => {
    setQuestion("Loading...");
    const endpoint = title.replace(" ", "%20");
    const url = process.env.REACT_APP_ICEBREAKERS_API;
    axios.get(url + endpoint).then((res) => setQuestion(res.data));
  };

  useEffect(() => {
    if (ib_category !== null) {
      title = ib_category;
    }
  }, [ib_category]);

  useEffect(() => {
    if (ib_category !== null) {
      updateQuestion(ib_category);
    }
  }, [ib_category]);

  useEffect(() => {
    let data = {
      action: "update-lobby-options",
      roomId: roomData.id,
      ib_current_player: activePlayerIndex,
    };
    Socket.sendMessage(data);
  }, [activePlayerIndex]);
  useEffect(() => {
    let data = {
      action: "update-lobby-options",
      roomId: roomData.id,
      ib_next_player: nextPlayerIndex,
    };
    Socket.sendMessage(data);
  }, [nextPlayerIndex]);

  const updateQuestion = (title) => {
    setQuestion("Loading...");
    const endpoint = title.replace(" ", "%20");
    const url = process.env.REACT_APP_ICEBREAKERS_API;
    axios.get(url + endpoint).then((res) => setQuestion(res.data));
  };

  const nextQuestion = () => {
    setNextPlayer();
    updateQuestion(title);
  };

  const sameQuestion = () => setNextPlayer();

  const setNextPlayer = () => {
    setActivePlayerIndex(
      (activePlayerIndex) => (activePlayerIndex + 1) % players.length
    );
  };

  // useEffect(() => {
  //   if (ib_question !== null) {
  //     setQuestion(ib_question);
  //   }
  // }, [ib_question]);

  useEffect(() => {
    let data = {
      action: "update-lobby-options",
      roomId: roomData.id,
      ib_question: question,
    };
    Socket.sendMessage(data);
  }, [question]);
  console.log(
    activePlayer?.profile_image.toString().includes("default-profile-icon"),
    activePlayer?.profile_image.toString().includes("profile-image"),
    "active===>>>"
  );

  return (
    <div className="cateory-content-wrapper">
      <Dropdown
        isOpen={dropdownOpen}
        toggle={toggle}
        className="category-dropdown"
      >
        <DropdownToggle caret>{title}</DropdownToggle>
        <DropdownMenu>
          {buttonData.map((item, index) => (
            <DropdownItem key={item.title} onClick={() => onClickItem(index)}>
              {item.title}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
      <div className="cat-text-content">
        <p className="cat-text">{ib_question}</p>
      </div>

      <div className="category-profile">
        <img
          className={cx("img", {
            defaultImage1: activePlayer?.profile_image
              .toString()
              .includes("default-profile-icon"),

            defaultImage: activePlayer?.profile_image
              .toString()
              .includes("profile-image"),
          })}
          src={
            activePlayer?.profile_image
              .toString()
              .includes("default-profile-icon")
              ? avatar
              : activePlayer?.profile_image.toString().includes("profile-image")
              ? avatar
              : activePlayer?.profile_image
          }
          alt="Profile_image"
        />
        {/* <p>{activePlayer?.display_name}</p> */}
        {/* <p>{playerName[0]}</p>
        {playerName[1] && <p>{playerName[1]}</p>} */}
        <p>{activePlayer?.display_name}</p>
      </div>
      <div className="questions-wrapper">
        <div className="text-left" style={{ textAlign: "left" }}>
          <button className="up-next-btn">
            {gameCode === "CT" ? "You're Up!" : "Up Next"}
          </button>
        </div>

        <div className="d-flex question-content">
          <div className="client-profile">
            <div className="client-profile-info">
              <img
                src={
                  nextPlayer?.profile_image
                    .toString()
                    .includes("default-profile-icon")
                    ? avatar
                    : nextPlayer?.profile_image
                        .toString()
                        .includes("profile-image")
                    ? avatar
                    : nextPlayer?.profile_image
                }
                alt="Profile_image"
              />
              <p>{nextPlayer?.display_name}</p>
            </div>
          </div>
          <div className="questions-btn">
            <button onClick={sameQuestion}>
              Same Question <i className="fas fa-redo-alt ml-2" />
            </button>
            <button onClick={nextQuestion}>
              {/* {gameCode === "CHPT" ? "Next Question" : "Next Player"} */}
              Next Question
              <i className="fas fa-arrow-right ml-2" />
            </button>
          </div>
        </div>
        {isLogoInsideCard && (
          <span className="poweredby">
            <label>Content Provided By </label>
            <img src={TrippleArrows} />
          </span>
        )}
      </div>
      {!isLogoInsideCard && (
        <span className="poweredby">
          <label>Content Provided By </label>
          <img src={TrippleArrows} />
        </span>
      )}
    </div>
  );
};
const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  socketReducer: state.socketReducer,
});

export default compose(withRouter, connect(mapStateToProps))(CategoryContent);
